// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__23hhS","image_biocentric":"Footer_image_biocentric__2fgzP"};